import {
    GridMenuButton,
    GridMenuItem,
} from '@/global/components/DataGrid/components/CustomGridToolBar/MenuComponents'
import { CsvMapper } from '@acme/core'
import { Box, Divider } from '@mui/material'
import { Button } from 'global/components/Button'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    ArrowDownToLine,
    ArrowUpDownIcon,
    ArrowUpToLineIcon,
    PlusIcon,
} from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { CentroCusto, centroCusto } from 'service/api'
import { useStore } from 'store'
import ArvoreCentroCusto from 'templates/Cadastro/CentroCusto/Arvore'

class CentroCustoMapper extends CsvMapper<Partial<CentroCusto>> {}

export default function CentroCustoPage() {
    const empresaId = useStore(state => state.companyId)
    const { data: fetchedData } = centroCusto.useFetch({
        queryParams: { empresaId },
        enabled: !!empresaId,
    })
    const data = fetchedData?.sort((a, b) => a.codigo.localeCompare(b.codigo))

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Centro de custos']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ArvoreCentroCusto fetchedData={data}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                            p: 1,
                        }}
                    >
                        <GridMenuButton
                            label="Integração"
                            startIcon={<ArrowUpDownIcon />}
                        >
                            <GridMenuItem
                                label="Exportar"
                                startIcon={
                                    <ArrowUpToLineIcon className="mr-2" />
                                }
                                onClick={() => {
                                    new CentroCustoMapper(
                                        (data ?? []).map(centro => ({
                                            id: centro.id,
                                            codigo: centro.codigo,
                                            nomeCentroCusto:
                                                centro.nomeCentroCusto,
                                            predecessorId: centro.predecessorId,
                                        })),
                                    ).downloadCsv('exportacao-centro-custo')
                                }}
                            />
                            {hasPermission(['create', 'CentrosDeCusto']) && (
                                <GridMenuItem
                                    label="Importar"
                                    startIcon={
                                        <ArrowDownToLine className="mr-2" />
                                    }
                                    href="importar"
                                />
                            )}
                        </GridMenuButton>
                        {hasPermission(['create', 'CentrosDeCusto']) && (
                            <Button href="adicionar" startIcon={<PlusIcon />}>
                                Adicionar
                            </Button>
                        )}
                    </Box>
                    <Divider
                        sx={{
                            mb: 1,
                            width: '100%',
                        }}
                    />
                </ArvoreCentroCusto>
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useCentroCustoOutletContext() {
    return useOutletContext<{
        data?: CentroCusto[]
    }>()
}
